import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './views/pages/home/home.component';
import { NotfoundComponent } from './views/pages/notfound/notfound.component';
import { AboutComponent } from './views/pages/about/about.component';
import { ContactComponent } from './views/pages/contact/contact.component';
import { MicrositeComponent } from './views/dept/microsite/microsite.component';
import { DegreesComponent } from './views/dept/degrees/degrees.component';
import { DegreeDetailsComponent } from './views/dept/degree-details/degree-details.component';
import { AllinfoComponent } from './views/pages/information/allinfo/allinfo.component';
import { InfoComponent } from './views/pages/information/info/info.component';
import { AllnewsComponent } from './views/pages/information/allnews/allnews.component';
import { AllotherComponent } from './views/pages/information/allother/allother.component';
import { DeanmsgComponent } from './views/pages/deanmsg/deanmsg.component';
import { FaqComponent } from './views/pages/faq/faq.component';
import { AllstaffComponent } from './views/pages/staff/allstaff/allstaff.component';
import { StaffmemberComponent } from './views/pages/staff/staffmember/staffmember.component';
import { DeptstaffComponent } from './views/pages/staff/deptstaff/deptstaff.component';
import {ResearchComponent} from './views/pages/research/research.component';
import {CounsellingComponent} from './views/pages/counselling/counselling.component';
import {HisArchiStuSocietyComponent} from './views/dept/society/his-archi-stu-society/his-archi-stu-society.component';
import {PaliBuddistAssocComponent} from './views/dept/society/pali-buddist-assoc/pali-buddist-assoc.component';
import {GeoEnvSciSocietyComponent} from './views/dept/society/geo-env-sci-society/geo-env-sci-society.component';
import {PublicPolicySocietyComponent} from './views/dept/society/public-policy-society/public-policy-society.component';
import {EcoSocialStuSocietyComponent} from './views/dept/society/eco-social-stu-society/eco-social-stu-society.component';
import {SocioAssoComponent} from './views/dept/society/socio-asso/socio-asso.component';
import {SiteSearchComponent} from './views/pages/site-search/site-search.component';
import {InternaltionlStuComponent} from './views/pages/internaltionl-stu/internaltionl-stu.component';
import {ResearchCentreComponent} from './views/pages/research-centre/research-centre.component';
import {ResearchCommitteeComponent} from './views/pages/research-committee/research-committee.component';
import {EthicsReviewCommitteeComponent} from './views/pages/ethics-review-committee/ethics-review-committee.component';
import {CalendarComponent} from './views/pages/lhms/calendar/calendar.component';
import {DailyweatherComponent} from "./views/pages/dailyweather/dailyweather.component";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'department',
    component: MicrositeComponent
  },
  {
    path: 'department/:id',
    component: MicrositeComponent
  },
  {
    path: 'department/:deptcode/:deptid',
    component: MicrositeComponent
  },
  {
    path: 'degrees',
    component: DegreesComponent
  },
  {
    path: 'degrees/:id',
    component: DegreesComponent
  },
  {
    path: 'degreedet/:degreeid',
    component: DegreeDetailsComponent
  },
  {
    path: 'allinfo',
    component: AllinfoComponent
  },
  {
    path: 'allinfo/:id',
    component: AllinfoComponent
  },
  {
    path: 'allinfo/:deptId/:infoId',
    component: AllinfoComponent
  },
  {
    path: 'info',
    component: InfoComponent
  },
  {
    path: 'info/:infoid',
    component: InfoComponent
  },
  {
    path: 'allnews/:deptId/:infoId',
    component: AllnewsComponent
  },
  {
    path: 'allnews',
    component: AllnewsComponent
  },
  {
    path: 'otherinfo/:infoId',
    component: AllotherComponent
  },
  {
    path: 'otherinfo/:deptId/:infoId',
    component: AllotherComponent
  },
  {
    path: 'deanmassage',
    component: DeanmsgComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'faq/:id',
    component: FaqComponent
  },
  {
    path: 'allstaff/:category/:catid',
    component: AllstaffComponent
  },
  {
    path: 'staff/:profile',
    component: StaffmemberComponent
  },
  {
    path: 'staff/:profile/:deptid',
    component: StaffmemberComponent
  },
  {
    path: 'deptstaff/:id',
    component: DeptstaffComponent
  },
  {
    path: 'research',
    component: ResearchComponent
  },
  {
    path: 'research/:id',
    component: ResearchComponent
  },
  {
    path: 'counselling',
    component: CounsellingComponent
  },
  {
    path: 'history_archaeology_students_society',
    component: HisArchiStuSocietyComponent
  },
  {
    path: 'association-of-pali-and-buddhist-studies',
    component: PaliBuddistAssocComponent
  },
  {
    path: 'geographical-environmental-science-society',
    component: GeoEnvSciSocietyComponent
  },
  {
    path: 'public-policy-society',
    component: PublicPolicySocietyComponent
  },
  {
    path: 'economics-and-social-statistics-society',
    component: EcoSocialStuSocietyComponent
  },
  {
    path: 'sociological-association',
    component: SocioAssoComponent
  },
  {
    path: 'international-students',
    component: InternaltionlStuComponent
  },
  {
    path: 'research-center',
    component: ResearchCentreComponent
  },
  {
    path: 'search/:phase',
    component: SiteSearchComponent
  },
  {
    path: 'research-committee',
    component: ResearchCommitteeComponent
  },
  {
    path: 'ethics-review-committee',
    component: EthicsReviewCommitteeComponent
  },
  {
    path: 'todayweather',
    component: DailyweatherComponent
  },
  {
    path: 'lhms/calendar',
    component: CalendarComponent
  },
  {
    path: 'notfound/:type',
    component: NotfoundComponent,
  },
  {
    path: '**',
    component: NotfoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
